<template>
	<form>
		<PersonNameForm ref="PersonNameForm" v-model="customer" @input="customerChanged" :disabled="disabled" />
		<div class="flex flex-wrap">
			<BaseInput
				ref="BaseInput-street"
				:required="true"
				class=" md:w-1/2 pl-0 md:pr-2"
				:label="$t('street')"
				:placeholder="$t('street')"
				type="text"
				@input="customerChanged"
				v-model="customer.street"
				:disabled="disabled"
			/>

			<BaseInput
				ref="BaseInput-housenumber"
				:required="false"
				class=" md:w-1/2 pl-0 md:pl-2"
				:label="$t('number')"
				:placeholder="$t('number')"
				type="tel"
				@input="customerChanged"
				v-model="customer.houseNumber"
				:disabled="disabled"
			/>
		</div>
		<CityInput ref="BaseInput-zip" v-model="customer.city" @input="customerChanged()" :disabled="disabled" />

		<div class="flex flex-wrap" v-if="showContactOptions">
			<BaseInput
				ref="BaseInput-telephone"
				:required="true"
				class=" md:w-1/2 pr-0 md:pr-2"
				:label="$t('phone')"
				:placeholder="$t('phone')"
				type="tel"
				validationtype="phone"
				@input="customerChanged"
				v-model="customer.phoneNumber"
				:disabled="disabled"
			/>
			<BaseInput
				ref="BaseInput-email"
				validationtype="email"
				:required="false"
				class=" md:w-1/2 pl-0 md:pl-2"
				:label="$t('e_mail')"
				:placeholder="$t('e_mail')"
				type="email"
				@input="customerChanged"
				:error-message="$t('e_mail_not_valid')"
				v-model="customer.email"
				:disabled="disabled"
			/>
		</div>
	</form>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import { _regxp } from '@/plugins/Utils';
import { stateMerge } from 'vue-object-merge';
import apiDefaults from '@/api/defaultConfiguration';
import { LocationsApiFactory } from '@/api/generated';
import PersonNameForm from '@/components/forms/PersonNameForm';
import Validate from '@/mixins/Validate';
import CityInput from '@/components/forms/CityInput';
import CleanBaseRadio from '@/components/forms/inputs/CleanBaseRadio.vue';

export default {
	name: 'CustomerForm',
	components: { CityInput, PersonNameForm, BaseInput },
	props: {
		startValue: {},
		disabled: { type: Boolean, default: false },
		showContactOptions: { type: Boolean, default: true },
	},
	mixins: [Validate],
	data() {
		return {
			customer: {
				city: {
					id: null,
					zipCode: null,
				},
				company: {
					name: null,
				},
			},
			regxp: _regxp(),
		};
	},
	methods: {
		clear() {
			this.$nextTick(() => {
				this.customer.city = {};
				this.customer.company = {};
				this.$refs.PersonNameForm.clear();
			});
		},
		zipCodeChanged: function() {
			if (this.customer.city.zipCode.toString().length === 5) {
				this.getCityToZipCode();
			} else {
				this.customer.city.name = null;
			}
		},
		customerChanged: function() {
			this.$emit('updateValue', this.customer);
		},
		getCityToZipCode: function() {
			LocationsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.locationsCitiesGet(this.customer.city.zipCode)
				.then(response => {
					this.customer.city = { ...response.data };
				})
				.catch(error => {
					//set name and id to null to remove city in ui
					this.customer.city.name = null;
					this.customer.city.id = null;
					this.$refs['BaseInput-zip'].isValid = false;
				});
		},
	},
	watch: {
		startValue: {
			handler() {
				if (this.startValue) {
					stateMerge(this.customer, this.startValue);
				}
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>
